import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Move = createSvgIcon(
  <path d="m8.676 6.84 2.199-2.345V9.75h2.25V4.495l2.199 2.345 1.641-1.539L12 .005 7.035 5.301l1.641 1.54Zm4.449 12.665 2.199-2.345 1.641 1.539L12 23.995l-4.965-5.296 1.641-1.54 2.199 2.346V14.25h2.25v5.255Zm6.38-8.63H14.25v2.25h5.255l-2.345 2.199 1.539 1.641L23.995 12l-5.296-4.965-1.54 1.641 2.346 2.199Zm-15.01 0H9.75v2.25H4.495l2.345 2.199-1.539 1.641L.005 12l5.296-4.965 1.54 1.641-2.346 2.199Z" />,
  'Move'
);

export { Move };